export default __webpack_public_path__ + "static/media/Ellipse 15.5446197d.png";